import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

const ActionRenderer = ({ onDelete, onView, onDownload, }) => {

    return (
        <div style={{ display: "flex", gap: "8px" }}>
            <span
                style={{ cursor: "pointer", color: "#254a9a" }}
                onClick={onView}
            >
                <VisibilityIcon />
            </span>
            <span
                style={{ cursor: "pointer", color: "#254a9a" }}
                onClick={onDownload}
            >
                <DownloadIcon />
            </span>
            <span
                style={{ cursor: "pointer", color: "#aa3939" }}
                onClick={()=>onDelete()}
            >
                <DeleteIcon />
            </span>
        </div>
    );
};

export default ActionRenderer;